import { container } from "../../material-kit-react.jsx";

const componentsStyle = {
  container,
  brand: {
    color: "#FFFFFF",
    textAlign: "left",
    zIndex: "2",
    position: "relative"
  },
  title: {
    fontSize: "4.7rem",
    fontWeight: "700",
    fontFamily: '"Montserrat", "Helvetica", sans-serif',
    display: "inline-block",
    position: "relative",
    lineHeight: "1.05",
    textShadow: "0 16px 40px rgba(0,0,0,0.34)",
    marginBottom: "0.75rem",
    maxWidth: "900px",
    "@media (max-width: 700px)": {
      fontSize: "2.7rem"
    }
  },
  subtitle: {
    fontSize: "1.08rem",
    maxWidth: "680px",
    margin: "12px 0 30px",
    fontWeight: "400",
    lineHeight: "1.75",
    textShadow: "0 1px 6px rgba(0,0,0,0.25)",
    opacity: "0.94"
  },
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3"
  },
  mainRaised: {
    margin: "0",
    borderRadius: "0",
    boxShadow: "none"
  },
  link: {
    textDecoration: "none"
  },
  textCenter: {
    textAlign: "center"
  },
  publicationMain: {
    background: "#FFFFFF",
    position: "relative",
    height: "1500px",
    zIndex: "3",
    margin: "20px 30px 0px",
    borderRadius: "6px",
    boxShadow:
      "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
  },
  pdf: {
    margin: "100px 30px 0px"
  }

};

export default componentsStyle;



// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-react/views/components.jsx